module.exports = __webpack_public_path__ + "static/media/balanceFilizola.6578e339.svg";